import React, { useEffect, useState } from 'react';
import AsDropdown from '../../generic/adserve-react-components/AsDropdown/AsDropdown';

export const networkType = {
    ALL: 0,
    NETWORK: 1,
    SUBNETWORK: 2,
    STATION: 3
};

const MultiSelection = ({
    id = 'spotTypeSelection',
    inputStyle,
    labelStyle,
    containerStyle,
    name,
    onApply,
    title,
    values,
    initialValues = [], // ASSP-7730
    height,
    readOnly,
    width = 229
}) => {
    const [localSelectedSpotTypes, setlocalSelectedSpotTypes] = useState([]);
    const [localSpotTypes, setLocalSpotTypes] = useState([]);

    useEffect(() => {
        setLocalSpotTypes(values);
    }, [values]);

    // ASSP-7730 Set the localSelectedSpotTypes from an array of ids
    useEffect(() => {
        // console.log('MultiSelection', title, initialValues, localSpotTypes)
        const selected = localSpotTypes.filter(s => initialValues.some(id => s.id === id));
        setlocalSelectedSpotTypes(selected);
        // console.log('MultiSelection selected', selected)
    }, [initialValues, localSpotTypes]);

    const handleTick = (selectedEntry) => {
        if (!selectedEntry.id) {
            if (localSelectedSpotTypes.find((st) => st.id === 0)) {
                setlocalSelectedSpotTypes([]);
            } else {
                setlocalSelectedSpotTypes([...localSpotTypes, selectedEntry]);
            }
            return;
        }
        if (localSelectedSpotTypes.find((s) => s.id == selectedEntry.id)) {
            const mutar = localSelectedSpotTypes.filter((s) => s.id && s.id !== selectedEntry.id);
            setlocalSelectedSpotTypes(mutar);
        } else {
            const mutar = [...localSelectedSpotTypes.filter((s) => s.id), selectedEntry];
            setlocalSelectedSpotTypes(mutar);
        }
    };

    const handleApply = () => {
        if (onApply) {
            onApply(localSelectedSpotTypes);
        }
    };
    const selectionText = () => {
        if (!localSpotTypes.length) return '';
        if (localSelectedSpotTypes.filter((t) => !t.id).length) return window.translate('Select...');
        return localSelectedSpotTypes.length === 0
            ? localSpotTypes?.length > 1
                ? window.translate('Select...')
                : localSpotTypes[0].name
            : localSelectedSpotTypes.length === 1
            ? values.find((s) => s.id === localSelectedSpotTypes[0].id)
            : window.translate('Multiple');
    };
    
    // ASSP-7730
    // console.log('MultiSelection', title, 'localSelectedSpotTypes', localSelectedSpotTypes)

    return (
        <>
            <AsDropdown
                id={id}
                activeValues={localSelectedSpotTypes}
                onApply={handleApply}
                onTick={handleTick}
                value={selectionText()}
                values={localSpotTypes}
                maxVisibleLength={557}
                title={title}
                name={name}
                inputStyle={inputStyle}
                labelStyle={labelStyle}
                containerStyle={containerStyle}
                style={{ width: width }}
                tongueStyle={{ zIndex: 250, marginTop: 0, width: width }}
                height={height}
                disabled={readOnly}
                applyRequired={true}
            />
        </>
    );
};

export default MultiSelection;
